const menuAboutPT = {
    "view": {
        "label": {
            "myProfile": "Meu Perfil",
            "twoFactorAuthentication": "Autenticação de Dois Fatores",
            "mySubscription": "Minha Assinatura",
            "announcements": "Anúncios",
            "mySubUsers": "Meus Subusuários",
            "myLabels": "Minhas Gravadoras",
            "escrowWallet": "Carteira de Depósito",
            "copyright": "Infrações de Direitos Autorais",
            "financialStatements": "Demonstrações Financeiras",
            "userStatements": "Declarações do Usuário",
            "subuserStatements": "Declarações do Subusuário",
            "invoices": "Faturas",
            "paymentMethods": "Métodos de Pagamento",
            "purchaseHistory": "Histórico de Compras",
            "accessKeys": "Chaves de Acesso",
            "logout": "Sair"
        }
    }
};

export default menuAboutPT;